import { AppScreen } from "../../AppScreen";
import { CustomEvent } from "../../events/CustomEvent";

export class ScreenChangeEvent extends CustomEvent
{
    public static SCREEN_CHANGED: string = "screenChangeEvent";

    constructor(type: string, public screen: AppScreen)
    {
        super(type);
    }
}
